/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown> }} Subtitle_Extract_Track_Op47Inputs */



/**
* | output |
* | --- |
* | "OP-47 Teletext page {page}" |
*
* @param {Subtitle_Extract_Track_Op47Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_track_op47 = /** @type {((inputs: Subtitle_Extract_Track_Op47Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Track_Op47Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`OP-47 Télétexte page ${i?.page}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`OP-47 Teletextseite ${i?.page}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Pagina Teletext OP-47 ${i?.page}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Страница телетекста OP-47 ${i?.page}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Página de teletexto OP-47 ${i?.page}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`OP-47 图文电视页 ${i?.page}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`OP-47 テレテキストページ ${i?.page}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`OP-47 टेलीटेक्स्ट पृष्ठ ${i?.page}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`OP-47 Página de teletexto ${i?.page}`)
	return /** @type {LocalizedString} */ (`OP-47 Teletext page ${i?.page}`)
});